import { Model } from '@vuex-orm/core'

export default class Session extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'sessions'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      is_current: this.attr(null),
      type: this.attr(null),
      ip: this.attr(null),
      device: this.attr(null),
      last_access: this.attr(null),
      expired_at: this.attr(null),
      created_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Session.js